import { C } from '@ridgewill/brand';
import { cleanTicketPrefix, ticketPrefixProblem } from '../lib/ticket-prefix.js';
import { Field, inputStyle } from './ui.js';

/**
 * The support ticket prefix, on registering and on editing an application.
 *
 * Just the letters, with the hyphen shown beside the box rather than typed
 * (Jon, 2026-09-27), and a live example of what a reference will look like, so
 * nobody has to imagine it.
 */
export function TicketPrefixField({
  value,
  onChange,
  saved,
}: {
  value: string;
  onChange: (value: string) => void;
  /** The prefix already stored, when editing. A change is explained. */
  saved?: string | null;
}) {
  const prefix = cleanTicketPrefix(value);
  const problem = ticketPrefixProblem(prefix);
  const changing = saved !== undefined && (saved ?? '') !== prefix;

  return (
    <Field
      label="Ticket prefix"
      error={problem ?? undefined}
      hint={
        prefix
          ? `Its support tickets look like ${prefix}-7HQ3MX.${changing && saved ? ` Tickets it already has keep ${saved}-.` : ''}`
          : 'Blank: its support tickets use the platform’s RW- prefix.'
      }
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: '.35rem' }}>
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={5}
          aria-label="Ticket prefix"
          style={{ ...inputStyle, width: '6rem', textTransform: 'uppercase', fontFamily: 'monospace' }}
        />
        <span aria-hidden style={{ color: C.muted, fontFamily: 'monospace' }}>
          -XXXXXX
        </span>
      </span>
    </Field>
  );
}
